<section class="document-readonly-page">
  <header class="page-head">
    @if (isPublicMode) {
      <p class="public-label">Shared read-only copy</p>
    } @else {
      <button type="button" class="back-link" (click)="navigateBackToList()">← Back to documents</button>
    }
  </header>

  @if (loading) {
    <p class="state-banner">Loading document view...</p>
  } @else if (errorMessage) {
    <div class="state-card">
      <p class="error-banner">{{ errorMessage }}</p>
      <button type="button" class="ghost-btn" (click)="retry()">Retry</button>
    </div>
  } @else if (document) {
    <app-read-only-pdf-review
      eyebrow="Document review"
      [title]="document.title"
      [copy]="reviewCopy"
      [metaItems]="reviewMetaItems"
      [pdfUrl]="pdfUrl"
      [fields]="document.fields"
      [fieldValues]="fieldValues"
      [brandSignatureFrame]="brandSignatureFrame"
      [signatureFrameMetadata]="signatureFrameMetadata"
      [maskTextboxes]="true"
      [emptyText]="pdfLoading ? 'Loading PDF preview...' : 'Preview unavailable.'"
    ></app-read-only-pdf-review>
  }
</section>
